import { CSSProperties } from 'react';

interface Props {
  style?: CSSProperties;
  color?: string;
}

export const AttachFileAdd = (props: Props) => {
  return (
    <svg
      width="24"
      height="24"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -960 960 960"
      style={props.style ? props.style : undefined}
      aria-label="attach-file"
      role="img"
    >
      <title id="svgTitle">ファイルアイコン</title>
      <path
        d="M640-520v-200h80v200h-80ZM440-244q-35-10-57.5-39T360-350v-370h80v476Zm30 164q-104 0-177-73t-73-177v-370q0-75 52.5-127.5T400-880q75 0 127.5 52.5T580-700v300h-80v-300q-1-42-29.5-71T400-800q-42 0-71 29t-29 71v370q-1 71 49 120.5T470-160q25 0 47.5-6.5T560-186v89q-21 8-43.5 12.5T470-80Zm170-40v-120H520v-80h120v-120h80v120h120v80H720v120h-80Z"
        fill={props.color ? props.color : undefined}
      />
    </svg>
  );
};
